



























import {
  ArticleCategory,
  ArticleStatus,
  IArticle,
  InvoiceBlock,
  InvoiceDto,
  InvoiceLine,
  QuotationBlock,
  QuotationDetailedDto,
  QuotationLine,
  SalesPrice,
} from '@/data/web-api-client';
import { roundToTwo } from '@/helpers/Helper';
import notificationService from '@/services/notificationService';
import { DxDataGrid, DxSwitch } from 'devextreme-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    DxSwitch,
    DxDataGrid,
  },
})
export default class ArticleSummaryTable extends Vue {
  @Prop({ required: true })
  entity!: QuotationDetailedDto | InvoiceDto;

  @Prop({ required: true })
  entityType!: EntityType;

  @Prop({ required: true })
  summary!: SummaryItem[];

  @Prop()
  articleCategories!: ArticleCategory[];

  hideInactiveArticles: boolean = true;

  getArticleSalesPrice(articleId: string): SalesPrice | null {
    if (!this.entity) {
      return null;
    }

    const article = this.articles.find((o: IArticle) => o.id === articleId);

    if (article && article.variants && article.variants.length > 0) {
      const variant = article.variants[0];
      if (variant && variant.salesPrices) {
        const type: string = this.entity.projectType ? this.entity.projectType : '';
        const salesPrice = variant.salesPrices.find((o) => o.type === type);
        if (salesPrice) {
          return salesPrice;
        }
      }
    }

    return null;
  }

  updateRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        // PRICE CHANGE
        var updateQuotation = false;
        if (e.newData.unitPrice) {
          if (this.entity && this.entity.blocks) {
            this.entity.blocks.forEach((block: InvoiceBlock | QuotationBlock) => {
              if (block.lines) {
                block.lines.forEach((line: InvoiceLine | QuotationLine) => {
                  if (line.articleId === e.oldData.articleId) {
                    line.price = e.newData.unitPrice;
                    updateQuotation = true;
                  }
                });
              }
            });
          }
        }
        if (updateQuotation) this.updateEntity();
        // ARTICLE CHANGE
        if (e.newData.articleId) {
          if (this.entity && this.entity.blocks) {
            this.entity.blocks.forEach((block: InvoiceBlock | QuotationBlock) => {
              if (block.lines) {
                block.lines.forEach((line: InvoiceLine | QuotationLine) => {
                  if (line.articleId === e.oldData.articleId) {
                    const article = self.articles.find((o: IArticle) => o.id === e.newData.articleId);
                    if (article) {
                      line.articleId = e.newData.articleId;
                      line.description = `${article.name}: ${article.description}`;
                    }
                  }
                });
              }
            });
          }
        }
        resolve(false);
      } catch (err) {
        notificationService.showErrorMessage('Er is iets misgelopen');
        reject(true);
      }
    });
  }

  updateEntity(): void {
    this.$emit('updateEntity');
  }

  setTextColor(e: any) {
    // price
    if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 2) {
      const salesPrice: SalesPrice | null = this.getArticleSalesPrice(e.data.articleId);
      if (salesPrice && salesPrice !== null) {
        const salesPriceRounded = roundToTwo(salesPrice.price!);
        const unitPriceRounded = roundToTwo(e.data.unitPrice);
        if (unitPriceRounded < salesPriceRounded) {
          $(e.cellElement).addClass('text-danger');
        }
        if (unitPriceRounded > salesPriceRounded) {
          $(e.cellElement).addClass('text-success');
        }
      }
    }
    // margin
    if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 4) {
      const salesPrice = this.getArticleSalesPrice(e.data.articleId);
      if (salesPrice) {
        const salesPriceRounded = roundToTwo(salesPrice.cost!);
        const unitPriceRounded = roundToTwo(e.data.unitPrice);
        if (unitPriceRounded < salesPriceRounded) {
          $(e.cellElement).addClass('text-danger');
        }
        if (unitPriceRounded > salesPriceRounded) {
          $(e.cellElement).addClass('text-success');
        }
      }
    }
    // Total margin
    if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 5) {
      const salesPrice = this.getArticleSalesPrice(e.data.articleId);
      if (salesPrice) {
        const salesPriceRounded = roundToTwo(salesPrice.cost!);
        const unitPriceRounded = roundToTwo(e.data.unitPrice);
        if (unitPriceRounded < salesPriceRounded) {
          $(e.cellElement).addClass('text-danger');
        }
        if (unitPriceRounded > salesPriceRounded) {
          $(e.cellElement).addClass('text-success');
        }
      }
    }
    if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 6) {
      const salesPrice = this.getArticleSalesPrice(e.data.articleId);
      if (salesPrice) {
        const salesPriceRounded = roundToTwo(salesPrice.cost!);
        const unitPriceRounded = roundToTwo(e.data.unitPrice);
        if (unitPriceRounded < salesPriceRounded) {
          $(e.cellElement).addClass('text-danger');
        }
        if (unitPriceRounded > salesPriceRounded) {
          $(e.cellElement).addClass('text-success');
        }
      }
    }
  }

  get articles(): IArticle[] {
    const articles: IArticle[] = this.$store.getters['articles/items'];
    if (this.hideInactiveArticles) {
      return articles.filter((o) => o.status === ArticleStatus.Active);
    }

    return articles;
  }

  get summaryColumns() {
    const self = this;

    const projectType = this.entity.projectType;
    return [
      {
        dataField: 'articleId',
        caption: 'Code',
        lookup: {
          dataSource: this.articles,
          displayExpr(val: any) {
            return `${val.name}: ${val.description}`;
          },
          allowClearing: false,
          valueExpr: 'id',
        },
        editorOptions: {
          disabled: true,
        },
        calculateDisplayValue(o: SummaryItem) {
          const article = self.articles.find((a) => a.id === o.articleId);
          return article ? `${article.name}: ${article.description}` : `${o.description}`;
        },
      },
      {
        dataField: 'quantity',
        caption: 'Aantal',
        dataType: 'number',
        format: {
          precision: 3,
        },
        alignment: 'left',
        editorOptions: {
          disabled: true,
        },
      },
      {
        caption: 'Stukprijs',
        columns: [
          {
            dataField: 'unitPrice',
            caption: 'Stukprijs',
            dataType: 'number',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
          },
          {
            caption: 'Origineel',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: { articleId: string; quantity: number; unitPrice: number }) {
              const article = self.articles.find((a) => a.id === value.articleId);
              if (!article) {
                return 0;
              }

              if (value && article.variants!.length > 0) {
                const variant = article.variants![0]; // .find((o) => o.name === value.variant);
                if (!variant) {
                  return 0;
                }
                const salesPrice = variant.salesPrices!.find((o) => o.type === projectType);
                if (!salesPrice) {
                  return 0;
                }
                return salesPrice.price;
              }

              return 0;
            },
          },
        ],
      },
      {
        caption: 'Marge',
        columns: [
          {
            caption: 'Marge',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: { articleId: string; quantity: number; unitPrice: number }) {
              const article = self.articles.find((a) => a.id === value.articleId);
              if (!article) {
                return 0;
              }

              if (value && article.variants!.length > 0) {
                const variant = article.variants![0]; // .find((o) => o.name === value.variant);
                if (!variant) {
                  return 0;
                }
                const salesPrice = variant.salesPrices!.find((o) => o.type === projectType);
                if (!salesPrice) {
                  return 0;
                }
                return value.unitPrice - salesPrice.cost!;
              }

              return 0;
            },
          },
          {
            caption: '%',
            format: {
              type: 'percent',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: { articleId: string; quantity: number; unitPrice: number }) {
              const article = self.articles.find((a) => a.id === value.articleId);
              if (!article) {
                return 0;
              }

              if (value && article.variants!.length > 0) {
                const variant = article.variants![0];
                if (!variant) {
                  return 0;
                }
                const salesPrice = variant.salesPrices!.find((o) => o.type === projectType);
                if (!salesPrice) {
                  return 0;
                }
                return (value.unitPrice - salesPrice.cost!) / salesPrice.cost!;
              }

              return 0;
            },
          },
          {
            caption: 'Totaal',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: { articleId: string; quantity: number; unitPrice: number }) {
              const article = self.articles.find((a) => a.id === value.articleId);
              if (!article) {
                return 0;
              }

              if (value && article.variants!.length > 0) {
                const variant = article.variants![0];
                if (!variant) {
                  return 0;
                }
                const salesPrice = variant.salesPrices!.find((o) => o.type === projectType);
                if (!salesPrice) {
                  return 0;
                }
                return (value.unitPrice - salesPrice.cost!) * value.quantity;
              }

              return 0;
            },
          },
        ],
      },
      {
        caption: 'Totaal',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: { articleId: string; quantity: number; unitPrice: number }) {
          if (value) {
            return value.unitPrice * value.quantity;
          }

          return 0;
        },
      },
      {
        groupIndex: 0,
        visible: false,
        dataField: 'articleCategoryId',
        calculateDisplayValue(value: SummaryItem) {
          const articleCategory = self.articleCategories.find((ac) => ac.id == value.articleCategoryId);

          let displayValue = articleCategory?.articleCategoryNumber ?? '';

          while (displayValue.endsWith('.0')) {
            displayValue = displayValue.slice(0, -2);
          }

          if (displayValue == '0') displayValue = '';

          return `${displayValue ?? ''} ${articleCategory?.name ?? 'Diverse'}`;
        },
        sortingMethod: (val1: any, val2: any) => {
          return 1;
        },
        groupCellTemplate: (row: any, value: any) => {
          $(row).append(`<div>${value.text ?? 'Diverse'}</div>`);
        },
      },
    ];
  }
}

export interface SummaryItem {
  articleId: string;
  description: string;
  quantity: number;
  unitPrice: number;
  articleCategoryId: string;
}

export type EntityType = 'Quotation' | 'Invoice' | 'CreditNote' | 'Contract' | 'Order';
